<template>
    <div v-html="content"  style="text-align:left;"></div>
</template>
<script>
const MarkdownIt = require('markdown-it')
const MarkdownItSize = require('markdown-it-imsize');
const md = new MarkdownIt();
md.use(MarkdownItSize);
export default {
    components: {
    },
    props:{
        source: String,
    },
    data(){
        return {
            content: ""
        };
    },
    async mounted(){
        this.content = md.render(this.source);
        console.log(this.source)
        console.log(this.content)
    }
}
</script>